// src/data/scentProfiles.js
// One scent profile per fragrance (roadmap 2.1), named from its notes.
// Used by the scent quiz to tell customers which profile they are, and sent
// to GA4 / Klaviyo / the Shopify order so customers can be grouped by it.
// partner is the contrasting scent the cart recommends alongside it (and a
// first draft of the Signature Pair, roadmap 1.3) — pairs are kept mutual.
// Keys are Shopify product handles. Wording is a draft for Adam to refine.

export const SCENT_PROFILES = {
    medina: {
        profile: 'Dark & Woody',
        partner: 'seville',
        tagline: 'Main character energy. You walk in, the room goes quiet.',
    },
    marrakech: {
        profile: 'Sweet & Smoky',
        partner: 'geneva',
        tagline: 'Well-travelled, a little mysterious, with stories you never fully tell.',
    },
    geneva: {
        profile: 'Warm & Spicy',
        partner: 'marrakech',
        tagline: 'Smells like the best hug of someone\'s life. No notes.',
    },
    beirut: {
        profile: 'Sweet & Gourmand',
        partner: 'damascus',
        tagline: 'Coffee, cacao and good decisions made after midnight.',
    },
    damascus: {
        profile: 'Fruity & Bright',
        partner: 'beirut',
        tagline: 'Sunshine with a caramel centre. Instantly likeable, slightly smug about it.',
    },
    seville: {
        profile: 'Refined & Understated',
        partner: 'medina',
        tagline: 'Quietly put together. People ask what you\'re wearing three days later.',
    },
    // The two new scents (launched at Marina Market, Oct 2026), paired with
    // each other: honeyed and dark against fresh and spiced.
    prague: {
        profile: 'Honeyed & Dark',
        partner: 'sao-paulo',
        tagline: 'Sweet, but never innocent. You\'d rather be intriguing than obvious.',
    },
    'sao-paulo': {
        profile: 'Fresh & Spiced',
        partner: 'prague',
        tagline: 'Fresh and dark, floral and spiced. For when one mood isn\'t enough.',
    },
};
